export default __webpack_public_path__ + "tels-navbar-logo-deddab55de7d5a71184854d310be4abf.svg";